import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';
import { FavoriteType } from 'shared/types/user-settings';

import { useUpdateUserSettings } from './use-update-user-settings';

export const useToggleFavorite = () => {
  const updateUserSettings = useUpdateUserSettings();
  const user = useUser();

  return useCallback(
    (id: ID, type: FavoriteType) => {
      const favorites = user?.settings?.favorites ?? [];
      const newFavorites = favorites.filter(
        (favorite) => !(favorite.type === type && favorite.id === id),
      );
      if (newFavorites.length === favorites.length) {
        newFavorites.push({ id, type });
      }
      updateUserSettings({ favorites: newFavorites });
    },
    [updateUserSettings, user?.settings?.favorites],
  );
};
